import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69ac407f886e1000141e44bb/videoportfolio/src/components/CursorSpotlight.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69ac407f886e1000141e44bb/videoportfolio/src/components/PageTransition.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69ac407f886e1000141e44bb/videoportfolio/src/components/ParticlesBackground.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69ac407f886e1000141e44bb/videoportfolio/src/styles/tailwind.css");
